import { objectOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsDirectCdiImportKeysKeyIdTestResult = objectOf({
  result: string,
  message: maybe(string),
});
